var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content"},[_c('toolbar',{attrs:{"selection":_vm.toolbar,"title":"Nuevo test de varroa"}}),_c('varroanueva',{attrs:{"idcolmena":_vm.idcolmena}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }